import React from 'react';
import { CoachingTimeOff } from 'coaching/containers/GetAvailableReservationsContainer';
import Row from 'components/Row';
import Copy from 'components/Copy';

type Props = {
  timeOff: CoachingTimeOff[];
};

export function formatTimeOffEntries(timeOffEntries: CoachingTimeOff[]) {
  const formattedDates = timeOffEntries
    .map(({ startDate, endDate }) => {
      if (startDate.isSame(endDate, 'day')) {
        return startDate.format('MMM D');
      } else if (startDate.isSame(endDate, 'month')) {
        return `${startDate.format('MMM D')} to ${endDate.format('D')}`;
      } else {
        return `${startDate.format('MMM D')} to ${endDate.format('MMM D')}`;
      }
    })
    .join(', ');

  const { startDate, endDate } = timeOffEntries[0];
  return timeOffEntries.length === 1 && startDate.isSame(endDate, 'day')
    ? `on ${formattedDates}`
    : `from ${formattedDates}`;
}

export default function CoachingSelfServeTimeOffView({ timeOff }: Props) {
  if (timeOff.length === 0) {
    return null;
  }

  const formattedDates = formatTimeOffEntries(timeOff);

  return (
    <Row>
      <Copy align="left" size="small">
        Remind Tutoring is on holiday {formattedDates} and will not be offering sessions then.
        Please double check the date you're selecting.
      </Copy>
    </Row>
  );
}
